import React from 'react';
import { CheckIcon, LockIcon, ShieldCheckIcon, SparkleIcon } from 'lucide-react';
import { Reveal } from './Reveal';
import { SectionHeading } from './SectionHeading';
import { CtaButton } from './CtaButton';
import { checkoutUrl, images, offerItems } from '../data/landing';
export function PurchaseSection() {
  return <section id="comprar" className="relative scroll-mt-16 overflow-hidden bg-gradient-to-b from-forest to-forest-deep px-5 py-14 sm:py-20" data-id="element-89" data-mp="2w34w40le7qvu">
      <div aria-hidden="true" className="pointer-events-none absolute inset-0" data-id="element-90" data-mp="3a1kyxgg4wx8p">
        <div className="absolute -right-24 top-10 h-72 w-72 rounded-full bg-gold/15 blur-3xl" data-id="element-91" data-mp="354ksh4fdhsh2" />
        <SparkleIcon className="twinkle absolute left-8 top-12 h-4 w-4 text-gold-light" data-id="element-92" data-mp="3jsz4o5yoitaa" />
        <SparkleIcon className="twinkle absolute bottom-20 right-10 h-5 w-5 text-gold-light [animation-delay:1.5s]" data-id="element-93" data-mp="3ev60figxs9cn" />
      </div>

      <div className="relative" data-id="element-94" data-mp="3ss2nr9xuj8os">
        <Reveal data-id="element-95" data-mp="3otdcpo0a638b">
          <SectionHeading tone="light" title="Empieza hoy a preparar tu hogar con más calma y claridad" subtitle="Accede ahora a El Escudo de Mamá y recibe los 3 bonos de regalo por un único pago." data-id="element-96" data-mp="3otv6mdzh05d2" />
        </Reveal>

        <Reveal delay={0.08} className="mx-auto mt-10 max-w-lg" data-id="element-97" data-mp="127yreepv0egh">
          <div className="overflow-hidden rounded-[28px] bg-cream shadow-lift ring-2 ring-gold/60" data-id="element-98" data-mp="176a2esrw4v0a">
            <img src={images.bundle} alt="El Escudo de Mamá junto a sus 3 bonos de regalo" className="block aspect-[16/9] w-full object-cover" data-id="element-99" data-mp="1c5wfn27pyb93" />
            <div className="p-6 sm:p-8" data-id="element-100" data-mp="1h4h7oecthomg">
              <ul className="space-y-3" data-id="element-101" data-mp="1l5sxajvoy9un">
                {offerItems.map(item => <li key={item} className="flex gap-3 text-[15px] font-medium leading-snug text-ink" data-id="element-102" data-mp="1l485v34ob710">
                    <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-gold" data-id="element-103" data-mp="1pzdont2s45kv">
                      <CheckIcon className="h-3 w-3 text-forest-deep" strokeWidth={3} aria-hidden="true" data-id="element-104" data-mp="1zvgyzm7sbaiw" />
                    </span>
                    {item}
                  </li>)}
              </ul>

              <div className="my-7 border-t border-dashed border-gold/50" data-id="element-105" data-mp="1f5wkurgmwjv5" />

              <div className="text-center" data-id="element-106" data-mp="1f3tlhgtldedr">
                <p className="text-sm font-semibold uppercase tracking-wide text-gold-deep" data-id="element-107" data-mp="1a7utzkcyvg94">
                  Precio de lanzamiento
                </p>
                <p className="mt-1 font-serif text-6xl font-bold text-forest sm:text-7xl" data-id="element-108" data-mp="1oxsm2be0oq3l">
                  $17 <span className="font-sans text-2xl font-bold" data-id="element-109" data-mp="1k3el7tgl5qrj">USD</span>
                </p>
                <p className="mt-2 text-sm text-ink-muted" data-id="element-110" data-mp="1xyqpargmstl4">
                  Pago único · Sin mensualidades · Sin pagos ocultos
                </p>
              </div>

              <div className="mt-6" data-id="element-111" data-mp="27tiqe59f9ykn">
                <CtaButton href={checkoutUrl} className="sm:w-full sm:px-6" data-id="element-112" data-mp="27shb1oldipx4">
                  Descarga El Escudo ahora por $17 USD
                </CtaButton>
                <p className="mt-3 flex items-center justify-center gap-1.5 text-center text-xs font-medium text-ink-muted" data-id="element-113" data-mp="dhlu9z01c4j9">
                  <LockIcon className="h-3.5 w-3.5 text-forest" aria-hidden="true" data-id="element-114" data-mp="8jsoh72n9cji" />
                  Compra segura · Acceso inmediato · Garantía de 7 días
                </p>
              </div>
            </div>
          </div>
        </Reveal>

        <Reveal delay={0.12} className="mx-auto mt-8 max-w-lg" data-id="element-115" data-mp="2afrsxld98qhj">
          <div className="flex items-start gap-4 rounded-3xl border border-gold/40 bg-forest-deep/60 p-5" data-id="element-116" data-mp="2adfbd9besi50">
            <div className="flex h-14 w-14 shrink-0 items-center justify-center rounded-full border-2 border-gold bg-gold/15" data-id="element-117" data-mp="21el6ywru6ngw">
              <ShieldCheckIcon className="h-7 w-7 text-gold-light" strokeWidth={1.75} aria-hidden="true" data-id="element-118" data-mp="25gf6h1qaplfh" />
            </div>
            <div data-id="element-119" data-mp="1rhp6nec3d7nf">
              <h3 className="font-serif text-lg font-semibold text-cream" data-id="element-120" data-mp="1ri8eu3bxwho9">
                Garantía de satisfacción de 7 días
              </h3>
              <p className="mt-1 text-sm leading-relaxed text-cream/80" data-id="element-121" data-mp="3ltwyujx13afi">
                Si revisas el material y sientes que no es para ti, puedes solicitar
                tu devolución dentro de los primeros 7 días.
              </p>
            </div>
          </div>
        </Reveal>
      </div>
    </section>;
}